export const appSettingsSegmentablePropertyUsage = "/app_settings/segmentable_property_usage";
